var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderLinked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1654 11.082V16.582C21.1654 20.2487 20.2487 21.1654 16.582 21.1654H7.41536C3.7487 21.1654 2.83203 20.2487 2.83203 16.582V7.41536C2.83203 3.7487 3.7487 2.83203 7.41536 2.83203H8.79036C10.1654 2.83203 10.4679 3.23536 10.9904 3.93203L12.3654 5.76536C12.7137 6.2237 12.9154 6.4987 13.832 6.4987H16.582C20.2487 6.4987 21.1654 7.41536 21.1654 11.082Z",
    stroke: "#0068FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3711 15.4401H14.0632C15.4473 15.4401 16.584 14.308 16.584 12.9193C16.584 11.5351 15.4519 10.3984 14.0632 10.3984H13.3711",
    stroke: "#0068FF",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6263 10.3984H9.9388C8.55005 10.3984 7.41797 11.5305 7.41797 12.9193C7.41797 14.3034 8.55005 15.4401 9.9388 15.4401H10.6263",
    stroke: "#0068FF",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.168 12.918H13.8346",
    stroke: "#0068FF",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderLinked);
export default __webpack_public_path__ + "static/media/folder-linked.c6e703e9f475321b28227b332ffc3a4b.svg";
export { ForwardRef as ReactComponent };